import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import { getAllMusicOnHold } from '../apiRequests/commonRequests'
import { getIVRSettings, getOnHoldMusics, getS3UrlRequest, getSoundLink, saveIVRSettingRequest, uploadRequest } from '../apiRequests/ivrRequests'





function* handleGetALLMusicOnHold() {
    try {
        const response = yield call(getOnHoldMusics)
        yield put({
            type: types.GET_ALL_MUSIC_ON_HOLD_SUCCESS,
            action: response,
        })
    } catch (error) {
        console.log(error)
        yield put({
            type: types.GET_ALL_MUSIC_ON_HOLD_ERROR,
            error: error.response,
        })
    }
}


function* handleGetIVRSettings(action) {
    try {
        const response = yield call(getIVRSettings, action.id)
        yield put({
            type: types.GET_IVR_SETTINGS_REQUEST_SUCCESS,
            action: response,
        })
    } catch (error) {
        console.log(error)
        yield put({
            type: types.GET_IVR_SETTINGS_REQUEST_ERROR,
            error: error.response,
        })
    }
}


function* handleGetAudioLink(action) {
    try {
        const response = yield call(getSoundLink, action.params)
        yield put({
            type: types.GET_AUDIO_LINK_REQUEST_SUCCESS,
            action: response,
        })
    } catch (error) {
        console.log(error)
        yield put({
            type: types.GET_AUDIO_LINK_REQUEST_ERROR,
            error: error.response,
        })
    }
}


function* handlePostIVRSettings(action) {
    try {

        const response = yield call(saveIVRSettingRequest, action.params)

        yield put({
            type: types.SAVE_IVR_SETTINGS_REQUEST_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SAVE_IVR_SETTINGS_REQUEST_ERROR,
            error: error.response,
        })
    }
}

function* handleGetS3UrlRequest(action) {
    try {

        const response = yield call(getS3UrlRequest, action.params)

        yield put({
            type: types.GET_S3URL_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_S3URL_ERROR,
            error: error.response,
        })
    }
}


function* handelUploadRequest(action) {
    try {

        const response = yield call(uploadRequest, action.params)

        yield put({
            type: types.UPLOAD_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.UPLOAD_ERROR,
            error: error.response,
        })
    }
}




function* watcherIVRRequestsSaga() {
    yield takeEvery(types.GET_IVR_SETTINGS_REQUEST, handleGetIVRSettings)
    yield takeEvery(types.GET_ALL_MUSIC_ON_HOLD, handleGetALLMusicOnHold)
    yield takeEvery(types.GET_AUDIO_LINK_REQUEST, handleGetAudioLink)
    yield takeEvery(types.SAVE_IVR_SETTINGS_REQUEST, handlePostIVRSettings)
    yield takeEvery(types.GET_S3URL_REQUEST, handleGetS3UrlRequest)
    yield takeEvery(types.UPLOAD_REQUEST, handelUploadRequest)



}

export default watcherIVRRequestsSaga
